// components
import { OldTooltip } from '@/components/sushi__old';
import styled from '@emotion/styled';

// theme
import { spacing, fontSizes, theme } from '../../utils';

//icons
import { InfoIcon } from '../Icon';

interface TooltipProps {
  text: string;
}

type CheckboxProps = {
  label?: string;
  disabled?: boolean;
  onChange: any;
  name: string;
  tooltip?: TooltipProps;
  defaultValue?: boolean;
  checked?: boolean;
};

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  user-select: none;
`;

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  disabled,
  defaultValue,
  checked,
  onChange,
  name,
  tooltip,
}) => {
  return (
    <CheckboxWrapper>
      <input
        type="checkbox"
        onChange={(e) => onChange(e.target.checked)}
        id={name}
        disabled={disabled}
        checked={checked}
        defaultChecked={defaultValue}
      />
      <label htmlFor={name}>{label && label}</label>
      {tooltip && (
        <OldTooltip
          html={
            <div className="cursor-pointer text-white text-12 font-semibold rounded-md bg-grey-500 p-1">
              {tooltip.text}
            </div>
          }
        >
          <InfoIcon size="small" color={theme.palette.grey[400]} />
        </OldTooltip>
      )}
      <style jsx>
        {`
          label {
            display: flex;
            cursor: pointer;
            font-weight: 600;
            font-size: 12px;
            align-items: center;
          }
          input[type='checkbox'] {
            display: none;
          }
          input[type='checkbox'] + label:before {
            content: '\a0';
            border: 1px solid #292929;
            border-radius: 5px;
            background: #3d3d3d;
            display: inline-block;
            width: 24px;
            height: 24px;
            padding-left: 5px;
            margin-right: 10px;
            color: #a3a3a3;
            line-height: 24px;
          }

          input[type='checkbox'] + label:active:before {
            transform: scale(1);
          }

          input[type='checkbox']:checked + label:before {
            content: '✓';
            background-color: #f1c086;
            border-color: #f1c086;
            color: #000;
          }
          input[type='checkbox']:disabled + label:before {
            border-color: #aaa;
          }

          input[type='checkbox']:checked:disabled + label:before {
            background-color: transparent;
            border-color: #D3D3D;
          }
        `}
      </style>
    </CheckboxWrapper>
  );
};

export default Checkbox;
